import { render, staticRenderFns } from "./MainLedgerCard3.vue?vue&type=template&id=32baedee&scoped=true"
import script from "./MainLedgerCard3.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard3.vue?vue&type=script&lang=js"
import style1 from "./otvoreneStavke.css?vue&type=style&index=1&id=32baedee&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32baedee",
  null
  
)

export default component.exports